import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7 17.97l5-2.15 5 2.15V5H7z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 14.97l-5-2.14-5 2.14V5h10v12.97z"
})), 'BookmarkTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookmarkTwoTone.js
// module id = 2402
// module chunks = 2